import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '../auth/protected.route';
//COMPONENTS
import ProviderRegister from './providerEntry/providerRegister.jsx';
import Confirmation from './providerEntry/confirmation.jsx';
import ForgotPassword from './providerEntry/forgotPassword.jsx';
import ResetPassword from './providerEntry/resetPassword.jsx';
import ProviderDashboard from './providerDashboard/providerDashboard.jsx';
import ProviderPreview from './providerPreview/providerPreview.jsx';
import PaymentStatus from './providerPayment/paymentStatus.jsx';
import StandaloneProviderProfile from './standaloneProviderProfile/StandaloneProviderProfile.jsx';
// import OnboardingFlow from './onboardingFlow/onboardingFlow.jsx'; // Temporarily disabled

const providerRoutes = (
	<Route path="/provider">
		<Route path="/provider/register" exact element={<ProviderRegister />} />
		<Route path="/provider/confirmation/:JWT" element={<Confirmation />} />
		<Route path="/provider/forgotpassword" exact element={<ForgotPassword />} />
		<Route path="/provider/reset/:JWT" exact element={<ResetPassword />} />
		<Route path="/provider/preview/:id" exact element={<ProviderPreview />} />
		{/* PROTECTED PROVIDER PATHS */}
		{/* Temporarily disabled onboarding - redirect to dashboard */}
		<Route
			path="/provider/onboarding"
			exact
			element={
				<ProtectedRoute>
					<Navigate to="/provider/dashboard" replace />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/provider/dashboard"
			exact
			element={
				<ProtectedRoute>
					<ProviderDashboard />
				</ProtectedRoute>
			}
		/>
		<Route
			exact
			path="/provider/paymentstatus"
			element={
				<ProtectedRoute>
					<PaymentStatus />
				</ProtectedRoute>
			}
		/>
		{/* Standalone shareable provider profile route - must be last to avoid conflicts */}
		<Route path="/provider/:id" exact element={<StandaloneProviderProfile />} />
	</Route>
);

export default providerRoutes;
